import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import JobService from './JobService';

export default class PolicyChangeService {
    static findJobByJobNumber(policyChangeNumber, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayChangePolicy'),
            'findJobByJobNumber',
            [policyChangeNumber],
            additionalHeaders
        );
    }

    static getPolicyChangeSummary(policyChangeNumber, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayChangePolicy'),
            'getPolicyChangeSummary',
            [policyChangeNumber],
            additionalHeaders
        );
    }

    static updatePolicyPeriodReQualificationQuestions_TWIA(policyChangeNumber, questionAnswers, submitting, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayPolicyChange'),
            'updatePolicyPeriodReQualificationQuestions_TWIA',
            [policyChangeNumber, questionAnswers, submitting],
            additionalHeaders
        );
    }

    static updatePolicyPeriodReQualificationQuestions_TFPA(policyChangeNumber, questionAnswers, submitting, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayPolicyChange'),
            'updatePolicyPeriodReQualificationQuestions_TFPA',
            [policyChangeNumber, questionAnswers, submitting],
            additionalHeaders
        ); 
    }

    static getNotesForPolicyChange(policyChangeNumber, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayChangePolicy'),
            'getNotesForPolicyChange',
            policyChangeNumber,
            additionalHeaders
        );
    }

    static createNoteForPolicyChange(params, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayChangePolicy'),
            'createNoteForPolicyChange',
            params,
            additionalHeaders
        );
    }

    static getDocumentsForPolicyChange(policyChangeNumber, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayChangePolicy'),
            'getDocumentsForPolicyChange',
            [policyChangeNumber],
            additionalHeaders
        );
    }

    static getUWIssuesForPolicyChange(policyChangeNumber, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayChangePolicy'),
            'getUWIssuesForPolicyChange',
            [policyChangeNumber],
            additionalHeaders
        );
    }

    static referToUnderwriter(policyChangeNumber, noteBody, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayChangePolicy'),
            'referToUnderwriter',
            [policyChangeNumber, noteBody],
            additionalHeaders
        );
    }

    static withdrawPolicyChangeByPolicyChangeNumber(
        policyChangeNumber,
        additionalHeaders
    ) {
        return JobService.withdrawJobByJobNumber(
            policyChangeNumber,
            additionalHeaders
        );
    }
}
